import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion"; 

export default function Approved() {
  return (
    <motion.div
      
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="min-h-screen flex flex-col justify-between bg-linear-to-b from-gray-100 via-green-100 to-green-700"
    >
      {/* Content Wrapper */}
      <div className="w-full">
        {/* Header Section */}
        <header className="px-6 py-8 w-full">
          <h1 className="text-2xl font-bold text-black">FINCA</h1>
        </header>

        <main className="flex flex-col items-center justify-center mt-10 px-6">
          
          {/* Celebration Icon  */}
          <motion.div 
            initial={{ scale: 0 }}
            animate={{ scale: 1, rotate: [0, 5, -5, 0] }}
            transition={{ 
              type: "spring", 
              stiffness: 260, 
              damping: 20, 
              delay: 0.2 
            }}
            className="relative h-24 w-24 bg-black rounded-full flex items-center justify-center mb-16 shadow-2xl"
          >
            <span className="text-6xl select-none">🎉</span>
            <div className="absolute -top-2 -right-2 text-2xl animate-pulse">✨</div>
          </motion.div>

          {/* Success Text */}
          <motion.div 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="text-center space-y-2 mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
              You've been
            </h1>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
              registered!
            </h1>
          </motion.div>

          {/* Login Link Button */}
          <Link to="/login" className="group">
            <motion.button 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="mt-8 self-center bg-black text-white px-10 py-4 rounded-full flex items-center gap-10 hover:bg-[#194e20] transition-colors shadow-xl cursor-pointer"
            >
              <span className="font-bold text-xl">Login</span>
              <span className="text-1xl group-hover:translate-x-2 transition-transform"> → </span>
            </motion.button>
          </Link>
        </main>
      </div>

      {/* Copyright Footer */}
      <footer className="px-6 py-8 text-center">
        <p className="text-white opacity-80 text-sm">
          Copyright © 2025 AADA. All rights reserved.
        </p>
      </footer>
    </motion.div>
  );
}